export const INTERVENTION_OPINION = {
  ABSOLUTELY: 'ABSOLUTELY',
  NO: 'NO',
  YES: 'YES',
  CALL_ME_BACK: 'CALL_ME_BACK',
};

export const INTERVENTION_STATUS = {
  ANSWERED: 'ANSWERED',
  CLOSED: 'CLOSED',
  DELETED: 'DELETED',
  IN_PROGRESS: 'IN_PROGRESS',
  OPEN: 'OPEN',
  READ: 'READ',
  SENT: 'SENT',
  TO_BE_COMPLETED: 'TO_BE_COMPLETED',
  TO_BE_SENT: 'TO_BE_SENT',
};

export const PAYMENT_STATUS = {
  PENDING: 'PENDING',
  ABORTED: 'ABORTED',
  FAILED: 'FAILED',
  SUCCESS: 'SUCCESS',
  PRE_AUTHORIZED: 'PRE_AUTHORIZED',
};

export const PAYMENT_TYPE = {
  DEPOSIT: 'DEPOSIT',
  FINAL_INVOICE: 'FINAL_INVOICE',
  FULL: 'FULL',
  EXTERNAL: 'EXTERNAL',
};

export const MODULES = {
  GUARANTEE: 'GUARANTEE',
  BODYWORK: 'BODYWORK',
  BODYWORK_APPOINTMENT: 'BODYWORK_APPOINTMENT',
  MECHANIC: 'MECHANIC',
  REMINDER: 'REMINDER',
  SALES_MESSAGE: 'SALES_MESSAGE',
  LEAD: 'LEAD',
  STOCK_VO: 'STOCK_VO',
  PARTS: 'PARTS',
  PARTS_REMINDER: 'PARTS_REMINDER',
};

export const CHECKLIST_GROUP_STATUS = {
  ACCEPTED: 'ACCEPTED',
  REFUSED: 'REFUSED',
  PENDING: 'PENDING',
};

export const FINAL_INVOICE_STATUS = {
  CREATED: 'CREATED',
  PAID: 'PAID',
  SENT: 'SENT',
  PRE_AUTHORIZED: 'PRE_AUTHORIZED',
};
